"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryApi = categoryApi;
exports.customerSKUSearchApi = customerSKUSearchApi;
exports.customerSkuPageApi = customerSkuPageApi;
exports.customerSkuTemplateApi = customerSkuTemplateApi;
exports.deleteBatchApi = deleteBatchApi;
exports.exportCustomerSkuApi = exportCustomerSkuApi;
exports.exportLowestPriceSkuApi = exportLowestPriceSkuApi;
exports.getBrandrApi = getBrandrApi;
exports.getCompanyListApi = getCompanyListApi;
exports.getCompanyOptionsApi = getCompanyOptionsApi;
exports.getRenshouSyncLogApi = getRenshouSyncLogApi;
exports.getSupplieGoodsrApi = getSupplieGoodsrApi;
exports.getSupplierApi = getSupplierApi;
exports.getSyncLogInfoApi = getSyncLogInfoApi;
exports.importCustomerSkuApi = importCustomerSkuApi;
exports.importUpdateCustomerSkuApi = importUpdateCustomerSkuApi;
exports.importUpdateCustomerSkuStatusApi = importUpdateCustomerSkuStatusApi;
exports.importUpdatePriceApi = importUpdatePriceApi;
exports.importUpdateStatusApi = importUpdateStatusApi;
exports.postGoodsApi = postGoodsApi;
exports.syncCategoryApi = syncCategoryApi;
exports.syncProductApi = syncProductApi;
exports.syncRenshouGoodsApi = syncRenshouGoodsApi;
exports.updatePriceApi = updatePriceApi;
exports.updateStatusApi = updateStatusApi;
exports.updateVirtualSalesApi = updateVirtualSalesApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 导出最低价SKU
 */
function exportLowestPriceSkuApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-sku/lowest-price-sku",
    method: 'GET',
    params: params
  });
}

/**
 * 分销商品导出
 */
function exportCustomerSkuApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-sku/customer-sku",
    method: 'GET',
    params: params
  });
}

/**
 * 移除
 */
function deleteBatchApi(data) {
  return (0, _request.default)({
    url: "/admin/customer-sku/deleteBatch",
    method: 'DELETE',
    data: data
  });
}

/**
 * 更新供货价和售价
 */
function updatePriceApi(params) {
  params = {
    supplyPrice: params.supplyPrice,
    // 供货价
    distributionPrice: params.distributionPrice,
    // 售价
    newcomerPrice: params.newcomerPrice,
    // 新人价
    id: params.id
  };
  return (0, _request.default)({
    url: "/admin/customer-sku/updatePrice/".concat(params.id),
    method: 'PUT',
    params: params
  });
}

/**
 * 更新虚拟销量
 */
function updateVirtualSalesApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-sku/updateVirtualSales/".concat(params.id),
    method: 'POST',
    params: {
      virtualSales: params.virtualSales
    }
  });
}

/**
 * 更新商家状态
 */
function updateStatusApi(data) {
  return (0, _request.default)({
    url: "/admin/customer-sku/updateStatus/".concat(data.id),
    method: 'PUT',
    params: data
  });
}

/**
 * 分页查询商品SKU信息
 */
function customerSkuPageApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-sku/page",
    method: 'GET',
    params: params
  });
}

/**
 * 保存商品
 */
function postGoodsApi(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: "/admin/customer-sku/saveSelectedSkus?customerId=".concat(data.customerId),
    method: 'POST',
    data: data,
    params: params
  });
}

/**
 * 添加商品时查询SKU信息列表（不分页）
 */
function customerSKUSearchApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-sku/search",
    method: 'GET',
    params: params
  });
}

/**
 * 品牌 keyword
 */
function getBrandrApi(params) {
  return (0, _request.default)({
    url: "/admin/store/brand/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 查询公司
 */
function getCompanyListApi(str) {
  return (0, _request.default)({
    url: "/admin/business/company/list/".concat(str ? str : ''),
    method: 'GET'
  });
}

/**
 * 模糊查询公司
 */
function getCompanyOptionsApi(par) {
  var data = _objectSpread(_objectSpread({}, par), {}, {
    status: 1
  });
  return (0, _request.default)({
    url: "/admin/business/company/options",
    method: 'GET',
    params: data
  });
}

/**
 * 商品分类
 * @param pram
 */
function categoryApi(params) {
  return (0, _request.default)({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: params
  });
}
/**
 * 供应商
 */
function getSupplierApi(params) {
  return (0, _request.default)({
    url: "/admin/business/supplier/autoList",
    method: 'GET',
    params: params
  });
}
// /**
//  * 查询供应商
//  */
// export function getSupplierApi(params) {
//   return request({
//     url: `/admin/business/supplier/list`,
//     method: 'GET',
//     params,
//   });
// }

/**
 * 查询供应商商品
 */
function getSupplieGoodsrApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/products/for-new/".concat(params.supplierId),
    method: 'GET',
    params: params
  });
}

/**
 * 分销商品模板导出
 */
function customerSkuTemplateApi() {
  return (0, _request.default)({
    url: "/admin/customer-sku/customer-sku-template",
    method: 'GET'
  });
}

/**
 * 导入修改价格
 */
function importUpdatePriceApi(formData, customerId, hasConfirm) {
  return (0, _request.default)({
    url: "/admin/customer-sku/importUpdatePrice?customerId=".concat(customerId, "&hasConfirm=").concat(hasConfirm),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 导入修改上下架状态
 */
function importUpdateStatusApi(formData, customerId) {
  return (0, _request.default)({
    url: "/admin/customer-sku/importUpdateStatus?customerId=".concat(customerId),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 导入修改上下架状态
 */
function importCustomerSkuApi(formData, customerId, hasConfirm) {
  return (0, _request.default)({
    url: "/admin/customer-sku/importCustomerSku?customerId=".concat(customerId, "&hasConfirm=").concat(hasConfirm),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
/**
 * 导入更新商品（异步版本）
 * 接口立即返回 taskId，后台异步处理，避免大文件超时
 */
function importUpdateCustomerSkuApi(formData, customerId, hasConfirm) {
  return (0, _request.default)({
    url: "/admin/customer-sku/importUpdateCustomerSku?customerId=".concat(customerId, "&hasConfirm=").concat(hasConfirm),
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 查询导入更新商品任务状态
 * @param {string} taskId - 由 importUpdateCustomerSkuApi 返回的任务 ID
 */
function importUpdateCustomerSkuStatusApi(taskId) {
  return (0, _request.default)({
    url: "/admin/customer-sku/importUpdateCustomerSku/status/".concat(taskId),
    method: 'GET'
  });
}

/**
 * 同步仁寿商品
 */
function syncRenshouGoodsApi() {
  return (0, _request.default)({
    url: "/admin/customer-sku/syncRenshouGoods",
    method: 'GET'
  });
}

/**
 * 获取仁寿同步日志
 */
function getRenshouSyncLogApi(params) {
  return (0, _request.default)({
    // 同步日志列表：/api/admin/sync/log/list （request会自动拼接 /api）
    url: "/admin/sync/log/list",
    method: 'GET',
    params: params
  });
}

/**
 * 获取同步日志详情
 * GET /api/admin/sync/log/info?id=xxx
 */
function getSyncLogInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/sync/log/info",
    method: 'GET',
    params: params
  });
}

/**
 * 分类同步
 * syncType: FULL(全量), INCREMENT(增量), UPDATE(修改)；不传默认FULL
 */
function syncCategoryApi(data) {
  return (0, _request.default)({
    url: "/admin/sync/category",
    method: 'POST',
    data: data
  });
}

/**
 * 商品同步
 * 传 storeId、customerId、syncType
 */
function syncProductApi(data) {
  return (0, _request.default)({
    url: "/admin/sync/product/sync",
    method: 'POST',
    data: data
  });
}